import { render, staticRenderFns } from "./LivingOptionMarkers.vue?vue&type=template&id=2b03a800&scoped=true"
import script from "./LivingOptionMarkers.vue?vue&type=script&lang=js"
export * from "./LivingOptionMarkers.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionMarkers.vue?vue&type=style&index=0&id=2b03a800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03a800",
  null
  
)

export default component.exports